module.exports = __webpack_public_path__ + "img/icon-step-9.b509032c.png";